import React, { ReactElement } from "react";
import { Controller } from "react-hook-form";
import EACheckbox from "../shared/Checkbox/EACheckbox";
import useFacility from "../../../utils/hooks/useFacility";
import { useSelector } from "react-redux";
import { State } from "../../store";

interface CheckboxConfig {
  name: string;
  required: boolean;
  label: string | ReactElement;
}

interface FacilityCheckboxConfig {
  facilityId: string;
  checkboxes: CheckboxConfig[];
}

interface IProps {
  errors: any;
  control: any;
}

// Konfiguracja checkboxów dla poszczególnych facilityId
const facilityCheckboxesConfig: FacilityCheckboxConfig[] = [
  {
    facilityId: "1200",
    checkboxes: [
      {
        name: "acceptRegulaminKS",
        required: true,
        label: (
          <span>
            *Akceptuję{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://panel.eaktywni.pl/img/1200/regulamin-KochamSkakac.pdf"
            >
              regulamin
            </a>{" "}
            oraz{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://panel.eaktywni.pl/img/1200/zgoda-rodzica-KS.pdf"
            >
              zgodę rodzica
            </a>
          </span>
        ),
      },
    ],
  },
    {
    facilityId: "1204",
    checkboxes: [
      {
        name: "acceptRegulaminKS",
        required: true,
        label: (
          <span>
            *Akceptuję{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://panel.eaktywni.pl/img/1200/regulamin-KochamSkakac.pdf"
            >
              regulamin
            </a>{" "}
            oraz{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://panel.eaktywni.pl/img/1200/zgoda-rodzica-KS.pdf"
            >
              zgodę rodzica
            </a>
          </span>
        ),
      },
    ],
  },
     {
    facilityId: "1227",
    checkboxes: [
      {
        name: "acceptRegulaminKS",
        required: true,
        label: (
          <span>
            *Akceptuję{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://panel.eaktywni.pl/img/1227/Regulamin_parku-skompresowany.pdf"
            >
              regulamin
            </a>{" "}
            oraz{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://panel.eaktywni.pl/img/1227/zgoda_kielce.pdf"
            >
              zgodę rodzica
            </a>
          </span>
        ),
      },
    ],
  },
];

const GuardianCheckboxes: React.FC<IProps> = ({ errors, control }) => {
  const facilityIds = useFacility();
  const newsletterActive = useSelector((state: State) => state.config.configuration?.newsLetterActive);

  // Znajdź konfigurację dla aktualnego facilityId
  const currentFacilityConfig = facilityCheckboxesConfig.find(
    (config) => config.facilityId === facilityIds
  );

  return (
    <div className="guardian-checkboxes__container">
      {/* Checkbox guardianDeclaration - zawsze wyświetlany */}
      <Controller
        name="guardianDeclaration"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <EACheckbox
            name="guardianDeclaration"
            field={field}
            errors={errors}
            label="*Oświadczam, że jestem rodzicem / opiekunem prawnym dalej podanych uczestników i mam ukończone 18 lat."
          />
        )}
      />

      {/* Checkboxy specyficzne dla facilityId */}
      {currentFacilityConfig?.checkboxes.map((checkbox) => (
        <Controller
          key={checkbox.name}
          name={checkbox.name as any}
          control={control}
          rules={{ required: checkbox.required }}
          render={({ field }) => (
            <EACheckbox
              name={checkbox.name}
              field={field}
              errors={errors}
              label={checkbox.label}
            />
          )}
        />
      ))}

      {/* Checkbox newsletter - jeśli aktywny */}
      {newsletterActive && (
        <Controller
          name="newsletterAgreement"
          control={control}
          render={({ field }) => (
            <EACheckbox
              name="newsletterAgreement"
              field={field}
              errors={errors}
              label={
                <span>
                  Wyrażam zgodę na otrzymywanie newslettera drogą mailową.
                </span>
              }
            />
          )}
        />
      )}
    </div>
  );
};

export default GuardianCheckboxes;
